import React, { useEffect, useState } from 'react';
import parsePhoneNumber from 'libphonenumber-js';
import styles from './PhoneNumberField.module.scss';
import TextField from '../../../TextField/TextField';
import Select from '../../../Select/Select';
import { SelectValue } from '../../../Select';
import { joinClasses } from '../../../../../../Utils/className.util';
import { useAppContext } from '../../../../../../Services/AppContext';
import { useEffectAsync } from '../../../../../../helpers';
import useTermItems from '../../../../Hooks/useTermItems';

interface PhoneNumberInputProps {
	onChange?: (phoneNumber: string) => void;
	value?: string;
	disabled?: boolean;
	placeholder?: string;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
	onChange,
	value,
	disabled = false,
	placeholder,
}) => {
	const { phonePrefix } = useAppContext();
	const [prefixes, setPrefixes] = useState<any[]>([]);
	const [prefix, setPrefix] = useState<SelectValue | undefined>({
		label: phonePrefix,
		value: phonePrefix,
	});
	const [number, setNumber] = useState<string | undefined>(undefined);
	const { getAsSelectValues } = useTermItems('phone_prefixes');

	useEffectAsync(async () => {
		const options = await getAsSelectValues({
			labelKey: 'value',
			valueKey: 'value',
		});
		setPrefixes(options);
	}, []);

	useEffect(() => {
		if (prefix?.label && number) {
			const phoneNumber = prefix?.label + '' + number;
			onChange?.(phoneNumber);
		}
	}, [prefix, number]);

	useEffect(() => {
		const parsedPhoneNumber = parsePhoneNumber(value || '');
		if (
			parsedPhoneNumber?.nationalNumber &&
			parsedPhoneNumber?.nationalNumber !== number
		) {
			setNumber(parsedPhoneNumber.nationalNumber);
		}
		if (
			parsedPhoneNumber?.countryCallingCode &&
			parsedPhoneNumber?.countryCallingCode !== prefix?.value
		) {
			setPrefix({
				value: `+${parsedPhoneNumber.countryCallingCode}`,
				label: `+${parsedPhoneNumber.countryCallingCode}`,
			});
		}
	}, [value]);

	const handlePrefixChange = (item: SelectValue) => {
		setPrefix(item);
	};

	const handleNumberChange = (text: string) => {
		setNumber(text);
	};

	return (
		<div className={joinClasses([styles.container, 'phoneNumberField'])}>
			<div className={joinClasses([styles.prefix, 'prefix'])}>
				<Select
					options={prefixes}
					onChange={handlePrefixChange}
					value={prefix}
					disabled={disabled}
					isSearchable
				/>
			</div>
			<div className={joinClasses([styles.number, 'number'])}>
				<TextField
					onChange={handleNumberChange}
					value={number}
					type='tel'
					placeholder={placeholder}
					disabled={disabled}
				/>
			</div>
		</div>
	);
};

export default PhoneNumberInput;
